import { render, staticRenderFns } from "./BaseOperationBox.vue?vue&type=template&id=6cfdda22&"
import script from "./BaseOperationBox.vue?vue&type=script&lang=js&"
export * from "./BaseOperationBox.vue?vue&type=script&lang=js&"
import style0 from "./BaseOperationBox.vue?vue&type=style&index=0&id=6cfdda22&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports